import Vue from 'vue'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import apiList from '~/api'
import { encryptWithPublicKey } from '~/utils/crypto'

// 这些接口失败时跳转到错误页，其余只弹通知
const ERROR_PAGE_URLS = [
  'app/house/queryInternalById',
  'app/house/housePkPlan/queryHousePkPlanDetail',
]

function shouldRedirectToErrorPage(config) {
  if (!config || !config.url) return false
  return ERROR_PAGE_URLS.some((url) => config.url.includes(url))
}

export function setupAxios(store, i18n, router) {
  // 本地 serve 走 devServer 代理（按 --mode 对应的后端）；build 后走完整 API 地址
  axios.defaults.baseURL =
    process.env.NODE_ENV === 'development' ? '' : process.env.VUE_APP_API_BASE_URL
  axios.defaults.timeout = 20000

  // Request interceptor
  axios.interceptors.request.use(
    async (config) => {
      config.headers['shm-language'] = i18n.locale === 'zh' ? 'zh-CN' : 'en-US'
      config.headers['shm-key'] = await encryptWithPublicKey(store.state.key)
      config.headers['shm-iv'] = await encryptWithPublicKey(store.state.iv)
      config.headers['tenant-id'] = store.state.tenantId || 1000
      return config
    },
    (err) => Promise.reject(err)
  )

  // Response interceptor
  axios.interceptors.response.use(
    (response) => {
      if (response.data.success || response.data.success === undefined) {
        return response.data
      }
      const data = response.data
      if (shouldRedirectToErrorPage(response.config)) {
        router.replace({
          path: '/error',
          query: { statusCode: data.code || data.status || 500, message: data.message || '' },
        })
      } else {
        notification.error({ message: '系统提示', description: data.message || '', duration: 4 })
      }
      return Promise.reject(data)
    },
    (err) => {
      if (err.response) {
        const code = err.response.status
        const message = (err.response.data && err.response.data.message) || ''
        if (shouldRedirectToErrorPage(err.config)) {
          router.replace({ path: '/error', query: { statusCode: code, message } })
        } else {
          notification.error({ message: '系统提示', description: message || `请求错误 ${code}`, duration: 4 })
        }
      } else if (err.code === 'ECONNABORTED') {
        notification.error({ message: '系统提示', description: '请求超时', duration: 4 })
      }
      return Promise.reject(err)
    }
  )

  // Mount $api on Vue prototype
  Vue.prototype.$api = {
    apiList: apiList(axios, store),
  }
}
